// The backup reminder rule (SPEC F8): the last backup is more than 14 days old and there are changes since.
// "Old" counts from the last backup, or from the first change when there has never been one.
import type { Settings } from '../data/types';

export const REMINDER_DAYS = 14;
const DAY_MS = 86_400_000;

export interface BackupStatus {
  /** Show the reminder. */
  due: boolean;
  /** Whole days since the last backup; undefined when there has never been one. */
  daysSince?: number;
  /** There are changes the last backup doesn't hold. */
  unsaved: boolean;
}

export function backupStatus(s: Pick<Settings, 'lastBackupAt' | 'lastChangeAt' | 'firstChangeAt'>, now: number): BackupStatus {
  const unsaved = s.lastChangeAt !== undefined && s.lastChangeAt > (s.lastBackupAt ?? 0);
  const since = s.lastBackupAt === undefined ? undefined : Math.floor((now - s.lastBackupAt) / DAY_MS);
  const base = s.lastBackupAt ?? s.firstChangeAt;
  const old = base !== undefined && now - base > REMINDER_DAYS * DAY_MS;
  return { due: unsaved && old, unsaved, ...(since === undefined ? {} : { daysSince: Math.max(0, since) }) };
}

/** "Never", "Today", "Yesterday", "5 days ago": the Backup screen's last-backup line. */
export function lastBackupLabel(daysSince: number | undefined): string {
  if (daysSince === undefined) return 'Never';
  if (daysSince <= 0) return 'Today';
  if (daysSince === 1) return 'Yesterday';
  return `${daysSince} days ago`;
}
